module.exports = __webpack_public_path__ + "static/boochheader-8f5a6ac021f967fbaacfa5b6acf00851.jpg";